import { UseQueryResult } from "react-query/types/react/types"

export const someAreLoading = (queriesToLoad : UseQueryResult[]) => {
    return queriesToLoad.some( (query) => query.isLoading)
}

export const someAreFetching = (queriesToLoad : UseQueryResult[]) => {
    return queriesToLoad.some( (query) => query.isFetching)
}

export const someAreIdle = (queriesToLoad : UseQueryResult[]) => {
    return queriesToLoad.some( (query) => query.isIdle)
}

export const someAreError = (queriesToLoad : UseQueryResult[]) => {
    return queriesToLoad.some( (query) => query.isError)
}